import { ChartBarIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Benchmark = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ChartBarIcon size={Sizes[size]} {...rest} color={fill} />;
};

Benchmark.displayName = 'Benchmark';
